__turbopack_context__.v({
  "container": "OutletInformation-module-scss-module__oNktvG__container",
  "contentContainer": "OutletInformation-module-scss-module__oNktvG__contentContainer",
  "infoSubTitle": "OutletInformation-module-scss-module__oNktvG__infoSubTitle",
  "infoTitle": "OutletInformation-module-scss-module__oNktvG__infoTitle",
  "informationItem": "OutletInformation-module-scss-module__oNktvG__informationItem",
});
